import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { push, goBack } from "connected-react-router";

import {
  INPUT_NUMBER,
  NEW_UUID_ORDER_ID,
  GET_RATES,
  CONVERT_CURRENCY,
  SELECTOR_CHANGED,
  RUN_KYC,
  STORE_PARAMS,
  NEW_ERROR,
  RESET_ERROR,
  GET_IP,
  GET_MOONPAY_URL,
  GET_URL,
} from "./";
import store from "../store";
import validate from "../utils/validate";

export const updateValue = (input) => (dispatch) => {
  const fiat_amount = store.getState().buy.fiat_amount;

  switch (input) {
    case ".":
      if (fiat_amount.indexOf(".") === -1) {
        dispatch({
          type: INPUT_NUMBER,
          payload: fiat_amount + ".",
        });
      } else if (fiat_amount === "0.00") {
        dispatch({
          type: INPUT_NUMBER,
          payload: "0.",
        });
      }
      break;
    case "⌫":
      if (fiat_amount.length === 1) {
        dispatch({
          type: INPUT_NUMBER,
          payload: "0",
        });
      } else {
        dispatch({
          type: INPUT_NUMBER,
          payload: fiat_amount.slice(0, -1),
        });
      }
      break;
    default:
      dispatch({
        type: INPUT_NUMBER,
        payload:
          fiat_amount === "0.00" || fiat_amount === "0"
            ? input
            : fiat_amount + input,
      });
      break;
  }
};

export const newUUID = (type) => (dispatch) => {
  switch (type) {
    case "order_id":
      dispatch({
        type: NEW_UUID_ORDER_ID,
        payload: uuidv4(),
      });
      break;
    default:
      break;
  }
};

export const getRates = (amount) => (dispatch) => {
  const state = store.getState();

  const data = {
    end_user_id: state.buy.params.user_id,
    requested_amount: amount,
    fiat_currency: state.buy.params.currencyCode,
    digital_currency: "LTC",
    requested_currency: state.buy.params.currencyCode,
    wallet_id: "litecoinfoundation",
    client_ip: state.buy.params.ip,
    payment_methods: ["simplex_account", "credit_card"],
  };

  axios({
    method: "post",
    url: "/api/buy/quote",
    headers: { "Content-Type": "application/json" },
    data,
  })
    .then((res) => res.data)
    .then((data) => {
      if (data["error"] !== undefined) {
        throw new Error(JSON.stringify(data));
      }
      dispatch({
        type: GET_RATES,
        payload: {
          quote_id: data.quote_id,
          base_amount: data.fiat_money.base_amount,
          total_amount: data.fiat_money.total_amount,
          digital_amount: data.digital_money.amount,
          valid_until: data.valid_until,
        },
      });
    })
    .catch((err) => console.error(err));
};

export const convertCurrency = () => (dispatch) => {
  const fiat_amount = store.getState().buy.fiat_amount;
  const rate = store.getState().buy.rates.base_amount;
  dispatch({
    type: CONVERT_CURRENCY,
    payload: String(Number(fiat_amount) / Number(rate)),
  });
};

export const changeSelector = (e) => (dispatch) => {
  if (e.target.id === "crypto") {
    dispatch({
      type: SELECTOR_CHANGED,
      payload: false,
    });
  } else {
    dispatch({
      type: SELECTOR_CHANGED,
      payload: true,
    });
  }
};

export const runKyc = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    const state = store.getState();

    const data = {
      user_id: state.buy.params.user_id,
      install_date: new Date(parseFloat(state.buy.params.appInstallDate)),
      transaction_details: {
        payment_details: {
          quote_id: state.buy.rates.quote_id,
          payment_id: state.buy.order_id,
          order_id: state.buy.order_id,
          fiat_total_amount: {
            currency: state.buy.params.currencyCode,
            amount: parseFloat(state.buy.rates.total_amount),
          },
          requested_digital_amount: {
            currency: "LTC",
            amount: parseFloat(state.buy.rates.digital_amount),
          },
          destination_wallet: {
            currency: "LTC",
            address: state.buy.params.address,
            tag: "",
          },
          original_http_ref_url: "https://litewallet.io",
        },
      },
    };

    axios({
      method: "post",
      url: "/api/buy/kyc",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((res) => {
        dispatch({
          type: RUN_KYC,
          payload: res.data.is_kyc_update_required,
        });
        return res.data.is_kyc_update_required;
      })
      .then((e) => {
        if (e === true) {
          axios
            .get("/api/url")
            .then((res) => res.data)
            .then((data) =>
              dispatch({
                type: GET_URL,
                payload: {
                  currentReturnBaseURL: data.currentReturnBaseURL,
                  currentPostURL: data.currentPostURL,
                },
              })
            )
            .then(() => {
              resolve();
            })
            .catch((err) => reject(err));
        }
      })
      .catch((err) => reject(err));
  });
};

export const getIP = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/ip")
      .then((res) => res.data)
      .then((data) =>
        dispatch({
          type: GET_IP,
          payload: data.ip,
        })
      )
      .then(resolve())
      .catch(reject());
  });
};

export const getParsedURL = (data) => (dispatch) => {
  let errors = [];

  let invalidWalletAddress = data.walletAddress === null;

  if (invalidWalletAddress) {
    errors.push("Missing litecoin address.");
  } else {
    let addressTest = validate(data.walletAddress);
    if (!addressTest) {
      errors.push("Invalid Address.");
    }
  }

  let invalidUserId = data.user_id === null;
  if (invalidUserId) {
    errors.push("Missing User Id.");
  }

  let passedCurrencyCode =
    data.currencyCode === null ? "USD" : data.currencyCode.toUpperCase();

  switch (passedCurrencyCode.toUpperCase()) {
    case "AUD":
    case "CAD":
    case "EUR":
    case "GBP":
    case "HKD":
    case "IDR":
    case "JPY":
    case "RUB":
    case "SGD":
    case "USD":
      data.currencyCode = passedCurrencyCode;
      break;
    default:
      data.currencyCode = "USD";
      break;
  }

  const appDateJSFormat = parseFloat(data.appInstallDate);
  let appInstallDateIsFloat = /^\d+$/.test(appDateJSFormat);
  if (!appInstallDateIsFloat) {
    errors.push("Invalid App Install Date Format.");
  }
  let appInstallDateTest = new Date(appDateJSFormat).getTime() > 0;
  if (!appInstallDateTest) {
    errors.push("Invalid App Install Date.");
  }

  data.appInstallDate = appDateJSFormat.toString();

  if (errors.length > 0) {
    dispatch({
      type: NEW_ERROR,
      payload: {
        error: true,
        messages: errors,
      },
    });
    return;
  }

  const state = store.getState();
  data.payment_id = state.buy.order_id;

  axios({
    method: "post",
    url: "/api/moonpayurl",
    headers: { "Content-Type": "application/json" },
    data,
  })
    .then((res) => {
      dispatch({
        type: GET_MOONPAY_URL,
        payload: res.data.url,
      });
    })
    .catch((err) => console.error(err));
};

export const storeParams =
  (partnerCode, address, code, idate, uid) => (dispatch) => {
    let payload = {
      partnerCode,
      address,
      currencyCode: code,
      appInstallDate: idate,
      user_id: uid,
      currencySymbol: "",
    };

    let errors = [];

    if (payload.address === null || payload.currencyCode === null) {
      errors.push("Missing litecoin address.");
      errors.push("Missing currency code.");

      dispatch({
        type: NEW_ERROR,
        payload: {
          error: true,
          messages: errors,
        },
      });
      return;
    }

    let addressTest = validate(payload.address);
    if (!addressTest) {
      errors.push("Invalid Address.");
    }
    payload.currencyCode = payload.currencyCode.toUpperCase();

    switch (payload.currencyCode.toUpperCase()) {
      case "AUD":
        payload.currencySymbol = "$";
        break;
      case "CAD":
        payload.currencySymbol = "$";
        break;
      case "EUR":
        payload.currencySymbol = "€";
        break;
      case "GBP":
        payload.currencySymbol = "£";
        break;
      case "HKD":
        payload.currencySymbol = "$";
        break;
      case "IDR":
        payload.currencySymbol = "Rp";
        break;
      case "JPY":
        payload.currencySymbol = "¥";
        break;
      case "RUB":
        payload.currencySymbol = "₽";
        break;
      case "SGD":
        payload.currencySymbol = "$";
        break;
      case "USD":
        payload.currencySymbol = "$";
        break;
      default:
        payload.currencyCode = "USD";
        payload.currencySymbol = "$";
        break;
    }

    const appDateJSFormat = parseFloat(payload.appInstallDate);
    let appInstallDateIsFloat = /^\d+$/.test(appDateJSFormat);
    if (!appInstallDateIsFloat) {
      errors.push("Invalid App Install Date Format.");
    }
    let appInstallDateTest = new Date(appDateJSFormat).getTime() > 0;
    if (!appInstallDateTest) {
      errors.push("Invalid App Install Date.");
    }

    payload.appInstallDate = appDateJSFormat.toString();

    if (errors.length !== 0) {
      dispatch({
        type: NEW_ERROR,
        payload: {
          error: true,
          messages: errors,
        },
      });
    }

    dispatch({
      type: STORE_PARAMS,
      payload,
    });
  };

export const pressBurgerButton = () => (dispatch) => {
  const state = store.getState();
  const location = state.router.location.pathname;

  if (location === "/" || location === "/success" || location === "/support") {
    dispatch(push("/close"));
  } else {
    dispatch(goBack());
  }
};

export const resetError = () => (dispatch) => {
  dispatch({
    type: RESET_ERROR,
    payload: {
      error: false,
      messages: [],
    },
  });
};
